import Observer from "../../../observer/observer.js";

import {
  modelData
} from "../../../../mixins/model-data.js";

import {
  defaultComparisonData,
  ActionType,
  CONNECTOR_URL,
  RequestAction
} from "../const.js";

import {
  sendXhr
} from "../../../../utils/send-xhr/send-xhr.js";
export default class ComparisonData extends Observer {
  constructor() {
    super();

    this._data = Object.assign(
        {},
        defaultComparisonData
    );

    this._requestQueue = null;
  }

  init() {
    window.ComparisonData = this;

    const requestArgs = {
      body: [
        `action=${RequestAction.GET_DATA}`,
      ],
      connectorUrl: CONNECTOR_URL,
      loadCallback: (response) => {
        const data = JSON.parse(response);
        this.changeData(Object.assign(
            {},
            data,
            {
              isInit: true
            }
        ), ActionType.GET_DATA);
      },
      requestQueue: this._requestQueue
    };
    sendXhr(requestArgs);
  }
}

Object.assign(ComparisonData.prototype, modelData);
